import Button from "react-bootstrap/Button";
import AnalysisPanelItem from "./AnalysisPanelItem";

import "./AnalysisPanel.scss";
import { useState } from "react";

const AnalysisPanel = (props) => {
  const { analyzeResult, handleNext } = props;

  const [currentSelection, setCurrentSelection] = useState("size");

  const angleData = analyzeResult?.tests.hasOwnProperty("angle") ?
    [
      {
        label: "Max angle",
        value: analyzeResult?.tests?.angle?.max_angle || "",
        file: analyzeResult?.tests?.angle?.file || "",
      },
      {
        label: "Min angle",
        value: analyzeResult?.tests?.angle?.min_angle || "",
      },
      analyzeResult?.tests?.angle?.sharp_angle ?
        {
          label: "Sharp angle",
          value: analyzeResult?.tests?.angle?.sharp_angle || "",
        }
        : null,
      analyzeResult?.tests?.angle?.sharp_length ?
        {
          label: "Sharp length",
          value: analyzeResult?.tests?.angle?.sharp_length || "",
        }
        : null,
    ]
    : [];

  const buildData = analyzeResult?.tests.hasOwnProperty("build") ?
    [
      analyzeResult?.tests?.build?.bottom ?
        {
          label: "Bottom",
          value: analyzeResult?.tests?.build?.bottom || {},
        }
        : null,
      analyzeResult?.tests?.build?.millable ?
        {
          label: "Millable",
          value: analyzeResult?.tests?.build?.millable || {},
        }
        : null,
      analyzeResult?.tests?.build?.unmillable ?
        {
          label: "UnMillable",
          value: analyzeResult?.tests?.build?.unmillable || {},
        }
        : null,
    ]
    : [];

  const sizeData = analyzeResult?.tests.hasOwnProperty("size") ?
    [
      {
        label: "Size",
        value: analyzeResult?.part?.size.toString().replaceAll(",", ",  ") || "",
      },
      {
        label: "Max size",
        value:
          analyzeResult?.tests?.size?.criteria?.max
            .toString()
            .replaceAll(",", ",  ") || "",
      },
      {
        label: "Min size",
        value:
          analyzeResult?.tests?.size?.criteria?.min
            .toString()
            .replaceAll(",", ",  ") || "",
      },
      analyzeResult?.tests?.size?.count > 1 ?
        {
          label: "Pack layout",
          value:
            analyzeResult?.tests?.size?.layout
              .toString()
              .replaceAll(",", " x ") || "",
        }
        : null,
    ].filter((item) => item)
    : [];

  const tunnelsData = analyzeResult?.tests.hasOwnProperty("tunnels") ?
    [
      {
        label: "Tunnels",
        value: analyzeResult?.tests?.tunnels?.tunnels || analyzeResult?.tests?.tunnels || {},
      },
      analyzeResult?.tests?.tunnels?.criteria?.min_top ?
        {
          label: "Min top/side",
          value: analyzeResult?.tests?.tunnels?.criteria?.min_top || "",
        }
        : null,
      analyzeResult?.tests?.tunnels?.top_dist ?
        {
          label: "Top distance",
          value: analyzeResult?.tests?.tunnels?.top_dist || "",
        }
        : null,
      analyzeResult?.tests?.tunnels?.side_dist ?
        {
          label: "Side distance",
          value: analyzeResult?.tests?.tunnels?.side_dist || "",
        }
        : null,
      analyzeResult?.tests?.tunnels?.criteria?.min_bot ?
        {
          label: "Min bottom",
          value: analyzeResult?.tests?.tunnels?.criteria?.min_bot || "",
        }
        : null,
      analyzeResult?.tests?.tunnels?.bot_dist ?
        {
          label: "Bottom distance",
          value: analyzeResult?.tests?.tunnels?.bot_dist || "",
        }
        : null,
    ].filter((item) => item)
    : [];

  const overhangData = analyzeResult?.tests.hasOwnProperty("overhangs") ?
    [
      {
        label: "Overhangs",
        value: analyzeResult?.tests?.overhangs?.overhangs || analyzeResult?.tests?.overhangs || {},
      },
      analyzeResult?.tests?.overhangs?.criteria?.max_overhang ?
        {
          label: "Max overhang",
          value: analyzeResult?.tests?.overhangs?.criteria?.max_overhang || "",
        }
        : null,
      analyzeResult?.tests?.overhangs?.max_overhang ?
        {
          label: "Over angle",
          value: analyzeResult?.tests?.overhangs?.max_overhang || "",
        }
        : null,
      analyzeResult?.tests?.overhangs?.over_area ?
        {
          label: "Over area",
          value: analyzeResult?.tests?.overhangs?.over_area || "",
        }
        : null,
    ].filter((item) => item)
    : [];

  const layerData = analyzeResult?.tests.hasOwnProperty("layer") ?
    [
      {
        label: "Layers",
        value: analyzeResult?.tests?.layer?.layers || "",
        file: analyzeResult?.tests?.layer?.file || analyzeResult?.tests?.layer?.layer?.file || "",
      },
      {
        label: "Length",
        value: analyzeResult?.tests?.layer?.length || "",
      },
      {
        label: "Area",
        value: analyzeResult?.tests?.layer?.area || "",
      },
      analyzeResult?.tests?.layer?.criteria?.area ?
        {
          label: "Small area",
          value: analyzeResult?.tests?.layer?.criteria?.area || "",
        }
        : null,
      analyzeResult?.tests?.layer?.criteria?.length ?
        {
          label: "Small length",
          value: analyzeResult?.tests?.layer?.criteria?.length || "",
        }
        : null,
      analyzeResult?.tests?.layer?.layer_small ?
        {
          label: "Small feature",
          value: analyzeResult?.tests?.layer?.layer_small || {},
        }
        : null,
    ].filter((item) => item)
    : [];

  const heightData = analyzeResult?.tests.hasOwnProperty("height") ?
    [
      analyzeResult?.tests?.height?.max_height_ratio ?
        {
          label: "Max height ratio",
          value: analyzeResult?.tests?.height?.max_height_ratio || "",
          file: analyzeResult?.tests?.height?.height?.file || "",
        }
        : null,
      {
        label: "Min height ratio",
        value: analyzeResult?.tests?.height?.criteria.height_ratio || "",
      },
      {
        label: "Min size",
        value: analyzeResult?.tests?.height?.criteria.min_size || "",
      },
    ].filter((item) => item)
    : [];

  const holeData = analyzeResult?.tests.hasOwnProperty("hole") ?
    [
      analyzeResult?.tests?.hole?.max_hole_ratio ?
        {
          label: "Max hole ratio",
          value: analyzeResult?.tests?.hole?.max_hole_ratio || "",
          file: analyzeResult?.tests?.hole?.hole?.file || "",
        }
        : null,
      {
        label: "Min hole ratio",
        value: analyzeResult?.tests?.hole?.criteria?.hole_ratio || "",
      },
    ].filter((item) => item)
    : [];

  const cutsimData = analyzeResult?.tests.hasOwnProperty("cutsim") ?
    [
      analyzeResult?.tests?.cutsim["20_cut_sim1"] ?
        {
          label: "20-thou",
          value: analyzeResult?.tests?.cutsim["20_cut_sim1"] || {},
        }
        : null,
      analyzeResult?.tests?.cutsim["10_cut_sim1"] ?
        {
          label: "10-thou",
          value: analyzeResult?.tests?.cutsim["10_cut_sim1"] || {},
        }
        : null,
      analyzeResult?.tests?.cutsim["6_cut_sim1"] ?
        {
          label: "6-thou",
          value: analyzeResult?.tests?.cutsim["6_cut_sim1"] || {},
        }
        : null,
    ].filter((item) => item)
    : [];

  const thin_wallData = analyzeResult?.tests.hasOwnProperty("thin_wall") ?
    analyzeResult?.tests?.thin_wall?.map((wall) => {
      let wall_key;
      Object.keys(wall).some((item) => {
        if (item.startsWith("wall+")) {
          wall_key = item;
          return true;
        }
        return false;
      });
      return wall_key ?
        {
          label: "Thickness: " + wall?.thickness,
          value: wall[wall_key],
        }
        : null;
    }).filter((item) => item)
    : [];

  const layer_overhangData = analyzeResult?.tests.hasOwnProperty("layer_overhang") ?
    [
      analyzeResult?.tests?.layer_overhang?.layers ?
        {
          label: "Layers",
          value: analyzeResult?.tests?.layer_overhang?.layers || "",
          file: analyzeResult?.tests?.layer_overhang?.file || "",
        }
        : null,
      analyzeResult?.tests?.layer_overhang?.layers ?
        {
          label: "Max overhang",
          value: analyzeResult?.tests?.layer_overhang?.criteria || "",
        }
        : null,
    ].filter((item) => item)
    : [];

  const panelDatas = {
    size: sizeData,
    build: buildData,
    cutsim: cutsimData,
    layer: layerData,
    height: heightData,
    hole: holeData,
    angle: angleData,
    overhangs: overhangData,
    layer_overhang: layer_overhangData,
    tunnels: tunnelsData,
    thin_wall: thin_wallData,
  };

  const handleClick = (header, file, violation) => {
    setCurrentSelection(header);
    props.handleInfoClick(
      file ? file : analyzeResult?.part?.file,
      header,
      violation
    );
  };

  return (
    <div className="left-panel">
      <h2 className="text-white mb-4">Summary of Results</h2>
      {typeof analyzeResult !== "undefined" &&
        Object.keys(panelDatas).filter((item) => analyzeResult?.tests[item]).map((item) => {
          if (panelDatas[item].length > 0) {
            const header = item.replaceAll("_", " ");
            return (
              <AnalysisPanelItem
                header={header}
                handleClick={handleClick}
                data={panelDatas[item]}
                isExpand={currentSelection === header}
                violation={analyzeResult?.tests[item]?.violation || ""}
              />
            )
          } else {
            return ("");
          }
        })}
      {!props.hideButton && (
        <div className="mt-5">
          <Button variant="primary w-100" onClick={handleNext}>
            Next
          </Button>
        </div>
      )}
    </div>
  );
};

export default AnalysisPanel;
